import { Injector, NgModule } from '@angular/core'
import { AngularFireModule } from '@angular/fire'
import { AngularFireAnalyticsModule, ScreenTrackingService } from '@angular/fire/analytics'
import { MatPaginatorIntl } from '@angular/material/paginator'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { ServiceLocator } from '@core/service/service-locator'
import { getPortuguesPaginatorIntl } from '@widgets/table-paginator/table-paginator-translate'
import { environment } from 'src/environments/environment'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { CoreModule } from './core/core.module'
import { ModalModule } from './modal/modal.module'

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,
    ModalModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
  ],
  providers: [{ provide: MatPaginatorIntl, useValue: getPortuguesPaginatorIntl() }, ScreenTrackingService],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
    ServiceLocator.initialize(this.injector)
  }
}
